<template>
    <img src="/images/promo/hero-section/glowing-star.png"
     alt="glowing star" />
</template>

<script>
export default {};
</script>
